const { QUAILTY_TRANSLATIONS } = require('../../../shared/constants/categories');

const MULTI = 'multi';
const SINGLE = 'single';
const PAIR = 'pair';

const DISPLAY_TYPES = {
    PRO: 'pro',
    RADIO: 'radio',
    INPUT_RANGE: 'input_range',
    CHECKBOX: 'checkbox',
    TOGGLE: 'toggle',
    CHECKBOX_GROUP: 'checkbox_group',
    MULTI_PAIRS_SELECT: 'multi_pairs_select'
};

const FILTER = {
    PRO: {
        ID: 'pro',
        SORT: 0,
        SELECTOR: SINGLE,
        DISPLAY_TYPE: DISPLAY_TYPES.PRO,
        SELECTED_VALUE: 'any',
        SELECTED_VALUE_ONLY: 'true',
        COOKIE_NAME: 'is_pro_toggled'
    },
    DELIVERY_TIME: {
        ID: 'delivery_time',
        SORT: 1,
        DISPLAY_TYPE: DISPLAY_TYPES.RADIO,
        SELECTOR: SINGLE,
        DEFAULT_FILTER: {
            min: 0,
            max: 10,
            count: 0
        },
        DEFAULT_IDS: ['1', '3', '7', '']
    },
    GIG_PRICE_RANGE: {
        ID: 'gig_price_range',
        SORT: 3,
        SELECTOR: SINGLE,
        DEFAULTS: {
            MIN: 0,
            MAX: 50000
        }
    },
    IS_SELLER_ONLINE: {
        ID: 'is_seller_online',
        SORT: 10,
        SELECTOR: SINGLE,
        DISPLAY_TYPE: 'checkbox'
    },
    SUBSCRIPTION: {
        ID: 'subscription',
        SORT: 1,
        SELECTOR: SINGLE,
        DISPLAY_TYPE: DISPLAY_TYPES.TOGGLE
    },
    CUSTOM_FILTER: {
        ID: 'customFilter',
        SORT: 4,
        SELECTOR: MULTI
    },
    PACKAGE_INCLUDES: {
        ID: 'package_includes',
        SORT: 5,
        SELECTOR: MULTI
    },
    SELLER_LEVEL: {
        ID: 'seller_level',
        SORT: 6,
        SELECTOR: MULTI,
        DEFAULT_IDS: ['top_rated_seller', 'level_two_seller', 'level_one_seller', 'na']
    },
    SELLER_LANGUAGE: {
        ID: 'seller_language',
        SORT: 7,
        SELECTOR: MULTI,
        WHITELIST: {
            any: true,
            en: true,
            es: true,
            fr: true,
            zh: true,
            de: true,
            ar: true,
            bn: true,
            my: true,
            nl: true,
            gu: true,
            he: true,
            hi: true,
            it: true,
            jp: true,
            jw: true,
            kn: true,
            kr: true,
            ml: true,
            mr: true,
            or: true,
            pa: true,
            fa: true,
            pl: true,
            'pt-BR': true,
            pt: true,
            ru: true,
            ta: true,
            te: true,
            th: true,
            tr: true,
            uk: true,
            ur: true,
            vi: true
        }
    },
    SELLER_LOCATION: {
        ID: 'seller_location',
        SORT: 11,
        SELECTOR: MULTI,
        FIRST_VIEW: {
            US: 1,
            GB: 2,
            CA: 3,
            DE: 4
        },
        WHITELIST: {
            AD: true,
            AE: true,
            AF: true,
            AG: true,
            AI: true,
            AL: true,
            AM: true,
            AN: true,
            AO: true,
            AQ: true,
            AR: true,
            AS: true,
            AT: true,
            AU: true,
            AW: true,
            AX: true,
            AZ: true,
            BA: true,
            BB: true,
            BD: true,
            BE: true,
            BF: true,
            BG: true,
            BH: true,
            BI: true,
            BJ: true,
            BL: true,
            BM: true,
            BN: true,
            BO: true,
            BQ: true,
            BR: true,
            BS: true,
            BT: true,
            BW: true,
            BY: true,
            BZ: true,
            CA: true,
            CC: true,
            CD: true,
            CF: true,
            CG: true,
            CH: true,
            CI: true,
            CK: true,
            CL: true,
            CM: true,
            CN: true,
            CO: true,
            CR: true,
            CU: true,
            CV: true,
            CX: true,
            CY: true,
            CZ: true,
            DE: true,
            DJ: true,
            DK: true,
            DM: true,
            DO: true,
            DZ: true,
            EC: true,
            EE: true,
            EG: true,
            EH: true,
            ER: true,
            ES: true,
            ET: true,
            FI: true,
            FJ: true,
            FK: true,
            FM: true,
            FO: true,
            FR: true,
            GA: true,
            GB: true,
            GD: true,
            GE: true,
            GF: true,
            GG: true,
            GH: true,
            GI: true,
            GL: true,
            GM: true,
            GN: true,
            GP: true,
            GQ: true,
            GR: true,
            GS: true,
            GT: true,
            GU: true,
            GW: true,
            GY: true,
            HK: true,
            HN: true,
            HR: true,
            HT: true,
            HU: true,
            ID: true,
            IE: true,
            IL: true,
            IM: true,
            IN: true,
            IO: true,
            IS: true,
            IT: true,
            JE: true,
            JM: true,
            JO: true,
            JP: true,
            KE: true,
            KG: true,
            KH: true,
            KI: true,
            KM: true,
            KN: true,
            KP: true,
            KR: true,
            KW: true,
            KY: true,
            KZ: true,
            LA: true,
            LC: true,
            LI: true,
            LK: true,
            LR: true,
            LS: true,
            LT: true,
            LU: true,
            LV: true,
            LY: true,
            MA: true,
            MC: true,
            MD: true,
            ME: true,
            MF: true,
            MG: true,
            MH: true,
            MK: true,
            ML: true,
            MM: true,
            MN: true,
            MO: true,
            MP: true,
            MQ: true,
            MR: true,
            MS: true,
            MT: true,
            MU: true,
            MV: true,
            MW: true,
            MX: true,
            MY: true,
            MZ: true,
            NA: true,
            NC: true,
            NE: true,
            NF: true,
            NG: true,
            NI: true,
            NL: true,
            NO: true,
            NP: true,
            NR: true,
            NU: true,
            NZ: true,
            OM: true,
            PA: true,
            PE: true,
            PF: true,
            PG: true,
            PH: true,
            PK: true,
            PL: true,
            PM: true,
            PN: true,
            PR: true,
            PS: true,
            PT: true,
            PW: true,
            PY: true,
            QA: true,
            RE: true,
            RO: true,
            RS: true,
            RU: true,
            RW: true,
            SA: true,
            SB: true,
            SC: true,
            SD: true,
            SE: true,
            SG: true,
            SH: true,
            SI: true,
            SJ: true,
            SK: true,
            SL: true,
            SM: true,
            SN: true,
            SO: true,
            SR: true,
            SS: true,
            ST: true,
            SV: true,
            SX: true,
            SZ: true,
            TC: true,
            TD: true,
            TG: true,
            TH: true,
            TJ: true,
            TK: true,
            TL: true,
            TM: true,
            TN: true,
            TO: true,
            TR: true,
            TT: true,
            TV: true,
            TW: true,
            TZ: true,
            UA: true,
            UG: true,
            US: true,
            UY: true,
            UZ: true,
            VA: true,
            VC: true,
            VE: true,
            VG: true,
            VI: true,
            VN: true,
            VU: true,
            WF: true,
            WS: true,
            XK: true,
            YE: true,
            YT: true,
            ZA: true,
            ZM: true,
            ZW: true
        }
    },
    NESTED_SUB_CATEGORIES: {
        ID: 'nested_sub_categories',
        SORT: 8
    },
    SUB_CATEGORIES: {
        ID: 'sub_categories',
        SORT: 9
    },
    LANGUAGES_PAIR: {
        ID: 'languages_pair',
        SORT: 3,
        DISPLAY_TYPE: DISPLAY_TYPES.MULTI_PAIRS_SELECT,
        SELECTOR: PAIR,
        INITIAL: ['*', '*'],
        DEFAULT: '*',
        OPTION_TYPES: {
            FROM: 'fromOptions',
            TO: 'toOptions'
        },
        TYPES: {
            FROM: 'from',
            TO: 'to'
        },
        SUB_CATEGORY_ID: QUAILTY_TRANSLATIONS.ID
    }
};

const ADDITIONAL_SELECTORS = {
    origin: SINGLE
};

const filterSelectorsMap = Object.keys(FILTER).reduce((map, filterKey) => {
    if (FILTER[filterKey]) {
        map[FILTER[filterKey].ID] = FILTER[filterKey].SELECTOR;
    }
    return map;
}, {});

const SELECTORS = {
    ...filterSelectorsMap,
    ...ADDITIONAL_SELECTORS,
    isPair(id) {
        return this[id] !== undefined ? this[id] === PAIR : false;
    },
    isMulti(id) {
        return this[id] !== undefined ? this[id] === MULTI : true;
    },
    getType(id) {

        if (this.isPair(id)) {
            return this.types.PAIR;
        }

        if (this.isMulti(id)) {
            return this.types.MULTI;
        }

        return this.types.SINGLE;
    },
    types: {
        MULTI,
        SINGLE,
        PAIR
    }
};

const SELECTED_DEFAULTS = {
    [FILTER.DELIVERY_TIME.ID] : '',
    [FILTER.GIG_PRICE_RANGE.ID]: [FILTER.GIG_PRICE_RANGE.DEFAULTS.MIN, FILTER.GIG_PRICE_RANGE.DEFAULTS.MAX],
    [FILTER.LANGUAGES_PAIR.ID] : FILTER.LANGUAGES_PAIR.INITIAL
};

const FILTER_TYPES = {
    GLOBAL: 'global',
    SPECIFIC: 'specific',
    SUB_CATEGORY: 'sub_category',
    MORE: 'more',
    TOGGLERS: 'togglers'
};

const TOP_GROUPING = {
    SERVICE: 1,
    SELLER: 2,
    DELIVERY_TIME: 3,
    BUDGET: 4,
    TOGGLERS: 5
};

const SEARCH_FILTER = {
    [FILTER.DELIVERY_TIME.ID]: 'filtered_duration',
    [FILTER.PACKAGE_INCLUDES.ID]: 'filtered_factors',
    [FILTER.GIG_PRICE_RANGE.ID]: 'filtered_price'
};

const TOP_GROUPING_MAP = {
    [FILTER.DELIVERY_TIME.ID]: TOP_GROUPING.DELIVERY_TIME,
    [FILTER.GIG_PRICE_RANGE.ID]: TOP_GROUPING.BUDGET,
    [FILTER.PRO.ID]: TOP_GROUPING.TOGGLERS,
    [FILTER.SELLER_LEVEL.ID]: TOP_GROUPING.SELLER,
    [FILTER.IS_SELLER_ONLINE.ID]: TOP_GROUPING.TOGGLERS,
    [FILTER.SUBSCRIPTION.ID]: TOP_GROUPING.TOGGLERS,
    [FILTER.SELLER_LANGUAGE.ID]: TOP_GROUPING.SELLER,
    [FILTER.SELLER_LOCATION.ID]: TOP_GROUPING.SELLER,
    [FILTER.PACKAGE_INCLUDES.ID]: TOP_GROUPING.SERVICE
};

const MAX_GIG_PRICE_RANGE = 50000;
const MIN_GIG_PRICE_RANGE = 0;

module.exports = {
    FILTER,
    FILTER_TYPES,
    SELECTORS,
    SELECTED_DEFAULTS,
    SEARCH_FILTER,
    GLOBAL_FILTERS: [FILTER.DELIVERY_TIME.ID, FILTER.GIG_PRICE_RANGE.ID, FILTER.SELLER_LANGUAGE.ID, FILTER.SELLER_LOCATION.ID, FILTER.SELLER_LEVEL.ID, FILTER.IS_SELLER_ONLINE.ID, FILTER.PRO.ID],
    SELECTED_EXCLUDED: [FILTER.IS_SELLER_ONLINE.ID, FILTER.PRO.ID, FILTER.SUBSCRIPTION.ID],
    TOUCH_EXCLUDED: [],
    REPORT_EXCLUDED: [FILTER.LANGUAGES_PAIR.ID],
    PATHFINDER: {
        NESTED_SUB_CATEGORY_PAGE: 'short_category_nested_sub_category',
        SUB_CATEGORY_PAGE: 'short_category_sub_category',
        CATEGORY_PAGE: 'category',
        SEARCH: 'search_gigs',
        ROOT: 'root',
        RELATED_SEARCH_TERMS: 'related_search_terms',
        PRO_HOMEPAGE: 'pro_homepage',
        STORE: 'store',
        LOGO_MAKER_PAGE: 'logo_maker_buyer_lp',
        STATIC_PAGE: 'static_page'
    },
    CATEGORY_FILTER_SOURCE: 'category_filters',
    UNKNOWN_ALIAS: 'Unknown Alias',
    MAX_SEARCH_SUB_CATEGORIES_FILTERS: 9,
    MAX_TOP_FILTERS_DISPLAY: 5,
    MAX_GIG_PRICE_RANGE,
    MIN_GIG_PRICE_RANGE,
    TOP_GROUPING,
    TOP_GROUPING_MAP,
    MULTI,
    SINGLE,
    PAIR,
    DISPLAY_TYPES
};
